import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { urlConstants } from '../../common/urlConstants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MyBasketWorkItems } from '../../models/work-item';

@Injectable({
  providedIn: 'root'
})
export class MyWorkBasketService {
  userGPID!: string | null;
  systemId!: string | null;

  constructor(private readonly http: HttpClient) {
    this.userGPID = localStorage.getItem("userGPID");
    this.systemId = localStorage.getItem('SelectedSystemId');
  }
  getMyWorkItemBasketDetails(): Observable<MyBasketWorkItems> {
    const routeUrl = `${environment.apiUrl}${urlConstants.myWorkItemBasket}${this.userGPID}/${this.systemId}`;
    return this.http.get<MyBasketWorkItems>(routeUrl);
  }

  downloadWorkItem(documentId: any): Observable<any> {
   const routeUrl = `${environment.apiUrl}${urlConstants.downloadWorkItem}${this.userGPID}/${this.systemId}/${documentId}`;
    return this.http.get(routeUrl, { responseType: 'text' });
  }
}
